import { Layout, Table } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { apiClient, apiErrorMessage } from '../../utils';

export function LoginAttemptLog() {
  const { Content } = Layout;

  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState<any[]>();

  useEffect(() => {
    setLoading(true);
    apiClient
      .get('users/login-attempts')
      .then(response => {
        setAttempts(response.data);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  const tableColumns = [
    {
      title: 'E-posta',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Zaman',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string) => moment(createdAt).format('DD.MM.yyyy HH:mm:ss'),
    },
    {
      title: 'Bilgiler',
      dataIndex: 'authInfo',
      key: 'authInfo',
      render: (authInfo: string) => {
        const authInfoObj = JSON.parse(authInfo);
        const authInfoItems = Object.keys(authInfoObj).map(key => key + ': ' + authInfoObj[key]);
        return (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {authInfoItems.map(a => (
              <li key="a">{a}</li>
            ))}
          </ul>
        );
      },
    },
  ];

  return (
    <Content>
      <Table columns={tableColumns} dataSource={attempts} loading={loading} pagination={false} />
    </Content>
  );
}
